import { config_lineChartEV, config_lineChartInt } from "../models/diagramsConfig";

const SeriesDataUpdate = (type, seriesType, party, seriesData) => {
        let position = 0;
        let partyID = party.id
        if (seriesType === 'scatter') { //partiesDataUpdate
                position = 2 * partyID;
                if(type === "evaluation") {
                        config_lineChartEV.series[position].data.push(seriesData);
                        if (partyID === 0) {
                                config_lineChartEV.xAxis.categories.push(seriesData[0]);
                        }
                }
                else if(type === "intention") {
                        config_lineChartInt.series[position].data.push(seriesData);
                        if (partyID === 0) {
                                config_lineChartInt.xAxis.categories.push(seriesData[0]);
                        }
                }
        }
        else if (seriesType === 'spline') { //movingAverageCalculation
                position = (2 * partyID) + 1;
                let seriesDataMa = Number(seriesData[1].toFixed(2));
                let seriesDataDate = seriesData[0];
                if(type === "evaluation") {
                        config_lineChartEV.series[position].data.push([seriesDataDate,seriesDataMa]);
                }
                else if(type === "intention") {
                        config_lineChartInt.series[position].data.push([seriesDataDate,seriesDataMa]);

                }
        }

}

export default SeriesDataUpdate;